import { Button } from '@cocoonspace/ui/components/button'
import { cn } from '@cocoonspace/ui/lib/utils'
import { BuildingIcon, CalendarClockIcon } from 'lucide-react'
import { parseAsStringLiteral, useQueryState } from 'nuqs'

export type ViewType = (typeof VIEW_TYPES)[number]

export const VIEW_TYPES = [
	'groupByDate',
	'groupBySpace',
	// 'list',
	// 'table',
] as const

export const useViewPicker = (defaultView?: ViewType) => {
	const [view, setView] = useQueryState(
		'viewType',
		parseAsStringLiteral(VIEW_TYPES)
			.withDefault(defaultView ?? 'groupByDate')
			.withOptions({ shallow: true }),
	)

	return { setView, view }
}

export const ViewPicker = () => {
	const { view, setView } = useViewPicker()

	return (
		<div className='flex items-center'>
			{VIEW_TYPES.map((currentView) => (
				<Button
					key={currentView}
					data-testid={`view-picker-btn-${currentView}`}
					size='sm'
					type='button'
					variant='ghost'
					className={cn(
						'border-border size-[32px] rounded-none border border-r-0 p-0 first:rounded-l-sm last:rounded-r-sm last:border-r',
						{
							'bg-primary/20 border-primary text-primary border-r':
								currentView === view,
							'border-l-0':
								VIEW_TYPES.indexOf(currentView) > 0 &&
								VIEW_TYPES[VIEW_TYPES.indexOf(currentView) - 1] === view,
						},
					)}
					onClick={() => setView(currentView)}
				>
					{currentView === 'groupByDate' && <CalendarClockIcon />}
					{currentView === 'groupBySpace' && <BuildingIcon />}
					{/* {currentView === 'list' && <ListIcon />} */}
					{/* {currentView === 'table' && <TableIcon />} */}
				</Button>
			))}
		</div>
	)
}
